import { Block } from '../models/Block';
import { Wod } from '../models/Wod';

export function filterWods(wods: Wod[] | null | undefined, keepEmpty = true): Wod[] {
  if (!Array.isArray(wods) || wods.length === 0) {
    return [];
  }

  return wods
    .filter((wod) => {
      const competitor = wod?.competitor ?? 0;
      return competitor === 0; // Solo mantener WODs donde competitor sea 0
    })
    .filter((w) => (keepEmpty ? true : Array.isArray(w.blocks) && w.blocks.length > 0));
}

export function filterBlocks(
  blocks: Block[] = [],
  excludes: string[] = ['COMPETITORS', 'COMPETIDORES'],
): Block[] {
  const excludeSet = new Set(excludes.map((t) => t.toString().trim().toUpperCase()));
  return blocks.filter((block) => {
    const title = (block.title ?? '').toString().trim().toUpperCase();
    return !excludeSet.has(title);
  });
}
// devuelve solo los blocks cuyo "tipo" coincida con alguno de los tipos pasados
export function filterBlocksByType(
  blocks: Block[] = [],
  types: string | string[] = [],
  // opcional: si quieres comprobar sólo un campo concreto en el block (ej: 'rankingType' o 'type' o 'title')
  field?: 'type_id',
): Block[] {
  if (!Array.isArray(blocks) || blocks.length === 0) return [];
  const arr = Array.isArray(types) ? types : [types];
  if (arr.length === 0) return [];

  const wanted = new Set(arr.map((t) => String(t).trim()));

  return blocks.filter((block: any) => {
    if (!block) return false;

    const checkValues: (string | undefined)[] = [];

    // si se solicita un campo concreto, lo consultamos primero
    if (field) {
      checkValues.push(String(block[field] ?? '').trim());
    } else {
      // campos por los que normalmente se determina el "tipo"
      checkValues.push(String(block.type_id ?? '').trim());
    }

    for (const raw of checkValues) {
      if (!raw) continue;
      const key = raw;
      if (wanted.has(key)) return true;
    }
    return false;
  });
}
